import {
  Checkbox,
  FormControl,
  Grid,
  Input,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  makeStyles,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { searchArray } from '../utils/Utils';

const useStyle = makeStyles({
  editButton: {
    height: '40px',
    width: '100px',
    marginRight: '10px',
  },
  count: {
    width: '30px',
    height: '30px',
    borderRadius: '50%',
    position: 'absolute',
    top: '50%',
    left: '7px',
    transform: 'translateY(-50%)',
    background: '#622FEE',
    color: '#fff',
    fontWeight: '500',
    fontSize: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: '99',
  },
  selectDropdown: {
    height: '40px',
    width: '250px',
    paddingLeft: '40px',
    borderRadius: '7px',
  },
  menuPaper: {
    marginTop: '8px',
    marginLeft: '-10px',
  },
});

export const MultiSelectDropdown = ({
  selectedData,
  data,
  onChangeFilter,
  onSelectedAllToggle,
  isSearchable,
  name,
  filedTitle,
}) => {
  const classes = useStyle();
  const [searchVal, setSearchVal] = useState('');
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    setFilteredData(data);
  }, [data]);

  const handleSearch = (e) => {
    e.stopPropagation();
    const input = e.target.value;
    let filteredVal = [];
    if (name === 'dealerGroup') {
      filteredVal = searchArray(data || [], ['name'], input);
    } else if (name === 'plans' || name === 'collections') {
      filteredVal = searchArray(data || [], ['title'], input);
    }
    setFilteredData(filteredVal || []);
    setSearchVal(input);
  };

  const getListItem = (item) => {
    if (name === 'source') {
      return (
        <MenuItem key={item} name={item} value={item}>
          <Checkbox color="primary" checked={selectedData?.some((i) => i === item)} />
          <ListItemText style={{ whiteSpace: 'normal' }} primary={item} />
        </MenuItem>
      );
    }
    if (name === 'dealerGroup') {
      return (
        <MenuItem key={item?.id} name={item?.id} value={item}>
          <Checkbox color="primary" checked={selectedData.some((i) => i?.id === item?.id)} />
          <ListItemText style={{ whiteSpace: 'normal' }} primary={item?.name} />
        </MenuItem>
      );
    }
    if (name === 'pxOwners') {
      return (
        <MenuItem key={item?.hash} name={item?.hash} value={item}>
          <Checkbox color="primary" checked={selectedData?.some((i) => i?.hash === item?.hash)} />
          <ListItemText style={{ whiteSpace: 'normal' }} primary={item?.name} />
        </MenuItem>
      );
    }
    if (name === 'plans' || name === 'collections') {
      return (
        <MenuItem key={item?.id} name={item?.id} value={item}>
          <Checkbox color="primary" checked={selectedData?.some((i) => i?.id === item?.id)} />
          <ListItemText style={{ whiteSpace: 'normal' }} primary={item?.title} />
        </MenuItem>
      );
    }
    return '';
  };

  return (
    <Grid>
      <FormControl>
        <Grid style={{ position: 'relative' }}>
          {selectedData?.length >= 1 && <Grid className={classes.count}>{selectedData?.length}</Grid>}
          <Select
            style={
              selectedData?.length >= 1
                ? { background: '#F4F3FF', border: '1px solid #D9D6FE' }
                : { background: '#FFFFFF' }
            }
            className={classes.selectDropdown}
            value={selectedData || []}
            onChange={(e) => {
              const selectedDataTemp = e.target.value;
              const len = selectedDataTemp.length;
              if (selectedDataTemp[len - 1] !== undefined) {
                if (selectedDataTemp[len - 1] !== 'all') {
                  onChangeFilter(name, selectedDataTemp);
                } else if (selectedData.length === data.length) {
                  onSelectedAllToggle(false);
                } else {
                  onSelectedAllToggle(true);
                }
              }
              if (selectedDataTemp?.length === 0) {
                onSelectedAllToggle(false);
              }
            }}
            input={<Input disableUnderline className={classes.textfield} />}
            displayEmpty
            renderValue={() => filedTitle}
            MenuProps={{
              getContentAnchorEl: null,
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
              },
              PaperProps: {
                className: classes.menuPaper,
                style: {
                  maxHeight: 48 * 4.5 + 8,
                  width: 350,
                },
              },
            }}
            multiple
          >
            {isSearchable && (
              <Grid
                style={{
                  width: '340px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <TextField
                  style={{ width: '95%', padding: '5px 10px', boxSizing: 'border-box' }}
                  InputProps={{
                    disableUnderline: true,
                  }}
                  variant="outlined"
                  placeholder="Search.."
                  value={searchVal}
                  onChange={(e) => handleSearch(e)}
                  onKeyDown={(e) => e.stopPropagation()}
                />
              </Grid>
            )}
            <MenuItem key="all" name="all" value="all">
              <Checkbox
                color="primary"
                checked={selectedData?.length === data?.length && selectedData?.length >= 1}
                onChange={(e) => onSelectedAllToggle(e.target.checked)}
              />
              <ListItemText primary="All" />
            </MenuItem>
            {filteredData?.map((i) => getListItem(i))}
          </Select>
        </Grid>
      </FormControl>
    </Grid>
  );
};
